import Lottie from "react-lottie-player";
import LoaderFile from "./loader.json";
import Backdrop from "@mui/material/Backdrop";
import { useSelector } from "react-redux";

export default function Loader() {
  const showLoader = useSelector((state) => state.auth.showLoader);
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 100000,
        position: "fixed", // Ensures it covers the entire viewport
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "0px !important",
        margin: 0,
      }}
      open={showLoader}
    >
      <div style={{ transform: "scaleX(-1)" }}>
        <Lottie
          loop
          animationData={LoaderFile}
          play
          style={{ width: 180, height: 180 }}
        />
      </div>
    </Backdrop>
  );
}
